module.exports = __webpack_public_path__ + "static/media/validation-checkmark.00c0ccd2.svg";